import { Button, Image, Input, Popover, Tabs, Tree, message } from "antd"
import { forwardRef, useCallback, useContext, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react"
import API, { commonApiInvoker } from "@api/api"
import { LoadingOutlined, PlusOutlined, SearchOutlined, CaretDownOutlined } from '@ant-design/icons';
import ImageItem from "@view/page_v3/FusionWear/components/ImageItem"
import styles from "./BatchReferSelection.module.scss"
import * as _ from "underscore";
import Utils from "@utils/utils"
import { IMAGE_TYPE, BATCH_IMAGES_TYPE, RESOURCE_TYPE, RESOURCE_PARAMS, SELECT_ORG_TYPE } from "@utils/CONST"
import PSAIModal from "@PSAIComponents/PSAIModal";
import CustomModelForm from "@view/page/selfModelFakeLeft/CustomModelForm";
import Iconfont from '@utils/Iconfont';
import eventBus from '@utils/eventBus'
import MoveFolderModal from "@view/page_v3/MaterialManage/components/MoveFolderModal";
import MaterialUploadModal from "@view/page_v3/MaterialManage/components/MaterialUploadModal";
import ReferFolderCard from "@view/page_v3/LeftComp/components/ReferFolderCard";
import { AppContext } from "@utils/AppContext";
import { CloseOutlined } from '@ant-design/icons';
const fallback = require('@assets/images/fallback.png')
const getSelectKey = (item) => item?.key || item?.name || item?.id
const PAGE_SIZE = 60

const getResourceData = (projectType) => {
    return projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ||
        projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? {
        func: "model",
        type: "tryOn",
    } : projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? {
        func: "model",
        type: "person",
    } : projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? {
        func: "model",
        type: "background",
    } : {}
}

const getResourceTypeByProjectType = (projectType) => {
    if (projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH) return RESOURCE_TYPE.MODEL
    if (projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) return RESOURCE_TYPE.MODEL_SCENE
    if (projectType == BATCH_IMAGES_TYPE.TRYON_BATCH || projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) return RESOURCE_TYPE.TRYON_MODEL
    return RESOURCE_TYPE.TRYON_MODEL
}

const getUploadSampleTypeByProjectType = (projectType) => {
    if (projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) return 'scene'
    if (projectType == BATCH_IMAGES_TYPE.TRYON_BATCH) return 'cloth'
    return 'model'
}

const transformFolderTreeData = (list) => {
    if (!Array.isArray(list)) return []
    return list.map((item) => {
        const node = {
            key: item.id,
            title: item.name,
            count: item.imageCount ?? 0,
            depth: item.depth ?? 0,
            isLeaf: !item.children || item.children.length === 0,
        }
        if (item.children && item.children.length > 0) {
            node.children = transformFolderTreeData(item.children)
        }
        return node
    })
}

const getAncestorKeysByFolderId = (list, targetId, ancestors = []) => {
    if (!Array.isArray(list) || targetId == null) return null
    for (const item of list) {
        const itemId = item?.id
        const nextAncestors = [...ancestors, itemId]
        if (String(itemId) === String(targetId)) {
            return ancestors
        }
        if (Array.isArray(item?.children) && item.children.length > 0) {
            const found = getAncestorKeysByFolderId(item.children, targetId, nextAncestors)
            if (found) return found
        }
    }
    return null
}

const CustomPoseList = forwardRef((props, ref) => {
    const removeRecordsFromList = useCallback((records = []) => {
        if (!records.length) return
        const removeIdSet = new Set(records.map(item => item?.id))
        setList(prev => prev.filter(item => !removeIdSet.has(item?.id)))
    }, [])

    useImperativeHandle(ref, () => ({
        refresh: () => updateForce(),
        removeRecords: (records = []) => removeRecordsFromList(records),
        onFavor: (record, favor) => {
            setList(pre => {
                const temp = [...pre]
                const item = temp.find(item => item.id == record.id)
                if (!item) return temp
                item.isFavorite = favor
                return [...temp]
            })
        }
    }))
    const [loading, setLoading] = useState(false)
    const [list, setList] = useState([])
    const [force, setForce] = useState(0)
    const updateForce = useCallback(() => setForce(prev => prev + 1), [])
    const [pageIndex, setPageIndex] = useState(1)
    const [hasMore, setHasMore] = useState(false)
    const [loadingMore, setLoadingMore] = useState(false)
    const loadingMoreRef = useRef(false)
    const requestIdRef = useRef(0)
    const isLoop = useRef()
    const isMounted = useRef(true)
    const customByMaterialList = useMemo(() => {
        return props.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ||
            props.projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH
    }, [props.projectType])
    const { globalOrgInfo } = useContext(AppContext)
    const hasOrg = globalOrgInfo?.orgList?.length > 1
    const [folderList, setFolderList] = useState([])
    const [folderTotal, setFolderTotal] = useState(0)
    const [activeFolder, setActiveFolder] = useState('refImage_all')
    const [activeFolderName, setActiveFolderName] = useState('全部参考图')
    const [folderOpen, setFolderOpen] = useState(false)
    const [expandedKeys, setExpandedKeys] = useState([])
    const [customKeyword, setCustomKeyword] = useState('')
    const [moveOpen, setMoveOpen] = useState(false)
    const [shareOpen, setShareOpen] = useState(false)
    const [uploadModalOpen, setUploadModalOpen] = useState(false)
    const [currentMoveResId, setCurrentMoveResId] = useState('')
    const treeData = useMemo(() => transformFolderTreeData(folderList), [folderList])
    const listRef = useRef([])

    const formatSimpleList = useCallback((items, isCustom = true) => {
        return (items || [])
            .filter(item => !String(item?.name || '').includes("_default_style"))
            .map(item => ({
                ...item,
                key: getSelectKey(item),
                isFavorite: item?.attr?.isFavorite,
                isCustom,
                attr: {
                    ...(item?.attr || {}),
                    title: item?.name || item?.attr?.title || '',
                    custom: isCustom
                }
            }))
    }, [])

    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    useEffect(() => {
        loadingMoreRef.current = loadingMore
    }, [loadingMore])

    const loopFunc = () => {
        updateForce()
        if (isLoop.current && isMounted.current) {
            setTimeout(() => {
                loopFunc()
            }, 2000)
        }
    }

    useEffect(() => {
        if (props.activeKey != "custom" && props.activeKey != "enterpriseCustom") return
        props.onChange(list.filter(item => (item?.attr && "maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true)))
    }, [props.activeKey, list])

    useEffect(() => {
        if (customByMaterialList) {
            if (isLoop.current) isLoop.current = false
            return
        }
        const notSucc = !!list.find(item => (item?.attr && "maskStatus" in item.attr ? item.attr?.maskStatus != "succeeded" : false))
        if (notSucc) {
            if (!isLoop.current) {
                isLoop.current = true
                loopFunc()
            }
        } else {
            if (isLoop.current) {
                isLoop.current = false
            }
        }
    }, [list, customByMaterialList])

    useEffect(() => {
        listRef.current = list
    }, [list])

    const loadCustomListPage = useCallback((targetPageIndex, reset = false) => {
        if (props.activeKey != "custom" && props.activeKey != "enterpriseCustom") return
        if (loadingMoreRef.current && !reset) return
        const requestId = requestIdRef.current + 1
        requestIdRef.current = requestId
        if (reset) {
            setPageIndex(1)
            setHasMore(false)
        } else {
            setLoadingMore(true)
        }
        const data = getResourceData(props.projectType)
        const folderId = activeFolder === 'refImage_all' ? '' : activeFolder
        const request = customByMaterialList ?
            API.materialList({
                scope: props.materialScope || "personal",
                folderId,
                keyword: customKeyword,
                pageIndex: targetPageIndex,
                pageSize: PAGE_SIZE,
                withAttr: true,
                func: data.func,
                type: data.type,
            }) :
            API.getCustomResources2({
                ...data,
                pageIndex: targetPageIndex,
                pageSize: PAGE_SIZE
            })
        commonApiInvoker(request).then(res => {
            if (requestIdRef.current !== requestId) return
            if (customByMaterialList) {
                const folders = (res?.subFolders || []).map(item => ({ ...item, type: 'folder' }))
                const images = res?.images || {}
                const total = images.total || 0
                const items = images?.items ?? []
                const list2 = formatSimpleList(items, true)
                if (reset) {
                    setList([...folders, ...list2])
                } else {
                    setList(prev => {
                        const prevFolders = prev.filter(item => item.type === 'folder')
                        const prevImages = prev.filter(item => item.type !== 'folder')
                        return [...prevFolders, ...prevImages, ...list2]
                    })
                }
                setPageIndex(targetPageIndex)
                setHasMore(targetPageIndex * PAGE_SIZE < total)
                return
            }
            const total = res?.total || 0
            const nextList = formatSimpleList(res?.items ?? [], true)
            if (reset) {
                setList(nextList)
            } else {
                setList(prev => [...prev, ...nextList])
            }
            setPageIndex(targetPageIndex)
            setHasMore(targetPageIndex * PAGE_SIZE < total)
        }).finally(() => {
            if (requestIdRef.current !== requestId) return
            setLoadingMore(false)
        })
    }, [props.activeKey, props.projectType, customByMaterialList, props.materialScope, activeFolder, customKeyword, formatSimpleList])

    useEffect(() => {
        loadCustomListPage(1, true)
    }, [force, props.activeKey, props.projectType, loadCustomListPage])

    useEffect(() => {
        if (!customByMaterialList) return
        API.materialFolderTree({ scope: props.materialScope || "personal" }).then((res) => {
            if (res?.code === 0) {
                const tree = Array.isArray(res?.data) ? res.data : []
                setFolderList(tree)
                setFolderTotal(res?.attr?.total ?? 0)
                return
            }
            setFolderList([])
            setFolderTotal(0)
        }).catch(() => {
            setFolderList([])
            setFolderTotal(0)
        })
    }, [force, customByMaterialList, props.materialScope])

    const expandFolderAncestors = useCallback((folderId) => {
        if (!folderId || folderId === 'refImage_all') return
        const ancestors = getAncestorKeysByFolderId(folderList, folderId) || []
        if (!ancestors.length) return
        setExpandedKeys(prev => Array.from(new Set([...(prev || []), ...ancestors])))
    }, [folderList])

    useEffect(() => {
        if (!customByMaterialList) return
        if (!folderList?.length) return
        expandFolderAncestors(activeFolder)
    }, [customByMaterialList, folderList, activeFolder, expandFolderAncestors])

    const [totalNum, setTotalNum] = useState(0)
    const [succNum, setSuccNum] = useState(0)
    const uploadFileWithAntispamId = (file) => {
        return Utils.checkImageIslegal(file, 1).then(res => {
            if (!res) return false
            if (!res.isLegal) {
                PSAIModal.confirm({
                    content: '经检测，您上传的内容涉嫌违规，已进行屏蔽处理，人工审核会对图片进行复核。',
                    okText: '重新上传',
                    cancelText: '取消',
                    onOk() {
                        Utils.openFile().then((res) => {
                            if (res) beforeUpload(res)
                        })
                    },
                    onCancel() { },
                })
                return false
            } else {
                const { imageAntispamId, data } = res
                return {
                    url: data,
                    imageAntispamId
                }
            }
        }).catch((err) => {
            message.error(err.message)
        })
    }
    function removeExtension(filename) {
        if (filename === '.' || filename === '..') return filename;
        const lastDot = filename.lastIndexOf('.');
        if (lastDot === -1 || lastDot === 0) return filename;
        return filename.substring(0, lastDot);
    }
    const doUploadFiles = async (fileList) => {
        if (!fileList?.length) return []
        if (fileList.length > 30) {
            message.warning("每次最多上传30张图")
            fileList = fileList.slice(0, 30)
        }
        const selectedKeys = []
        setSuccNum(0)
        setTotalNum(fileList.length)
        setLoading(true)
        const uploadedItems = []
        for (let file of fileList) {
            const name = removeExtension(file.name)
            let isNromal = false
            
            isNromal = await Utils.validateImageFile(file)
            
            if (!isNromal) continue
            const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
            if (!resizeRes || !resizeRes.success) { message.warning(resizeRes?.message); continue; }
            file = resizeRes.file
            try {
                const res = await uploadFileWithAntispamId(file)
                if (!res) continue
                const { url, imageAntispamId } = res
                if (customByMaterialList) {
                    uploadedItems.push({
                        imageUrl: url,
                        name: `${name}`,
                        folderId: activeFolder === 'refImage_all' ? '' : activeFolder,
                        scope: props.materialScope || "personal",
                        attr: { title: `${name}` },
                    })
                } else if (props.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) {
                    const res2 = await API.saveCustomMaterialv2({
                        func: IMAGE_TYPE.MODEL,
                        type: 'background',
                        image: url,
                        attr: {
                            title: `${name}`,
                        }
                    })
                    if (res2?.code != 0) throw new Error(res2?.message)
                } else {
                    const res2 = await API.saveCustomTryOnModel({
                        tryOnImage: url,
                        thumbnail: url,
                        imageAntispamId,
                        title: `${name}`,
                        async: 1
                    })
                    if (res2?.code != 0) throw new Error(res2?.message)
                }
                setSuccNum(pre => pre + 1)
            } catch (err) {
                console.error(err)
            }
        }
        if (customByMaterialList && uploadedItems.length > 0) {
            try {
                const saveRes = await API.materialResBatchSave({ items: uploadedItems })
                if (saveRes?.code != 0) throw new Error(saveRes?.message)
                const data = getResourceData(props.projectType)
                const listRes = await commonApiInvoker(API.materialList({
                    scope: props.materialScope || "personal",
                    folderId: activeFolder === 'refImage_all' ? '' : activeFolder,
                    keyword: customKeyword,
                    pageIndex: 1,
                    pageSize: 2000,
                    withAttr: true,
                    func: data.func,
                    type: data.type,
                }))
                const images = listRes?.images?.items || []
                uploadedItems.forEach((uploadItem) => {
                    const hit = images.find(img => img?.imageUrl === uploadItem.imageUrl || img?.name === uploadItem.name)
                    if (!hit) return
                    props.onClick({
                        ...hit,
                        attr: {
                            ...(hit?.attr || {}),
                            title: hit?.name || hit?.attr?.title || '',
                            custom: true
                        }
                    })
                    const selectKey = getSelectKey(hit)
                    if (selectKey) selectedKeys.push(selectKey)
                })
            } catch (err) {
                message.error(err?.message || "上传失败")
            }
        }
        updateForce()
        setLoading(false)
        return selectedKeys
    }
    const uploadDebounce = useCallback(_.debounce((file, fileList) => {
        doUploadFiles(fileList)
    }, 100), [props.projectType, customByMaterialList, props.materialScope])
    const beforeUpload = async (file, fileList) => {
        uploadDebounce(file, fileList)
        return false
    }
    const handleDrop = async (e) => {
        e.stopPropagation()
        if ("getFilesAndDirectories" in e.dataTransfer) {
            const filesAndDirs = await e.dataTransfer.getFilesAndDirectories()
            const fileList = await Utils.getFilesFromDirs(filesAndDirs, "/")
            console.log('===handleDrop===')
            uploadDebounce(fileList[0], fileList)
            return false
        }
    }
    const handleModalUpload = useCallback(async (file) => {
        const uploadedKeys = await doUploadFiles([file])
        return uploadedKeys.length > 0
    }, [doUploadFiles])
    const handleRemove = (record) => {
        PSAIModal.confirm({
            title: `确定删除这张自定义模特？`,
            onOk() {
                const request = customByMaterialList ?
                    API.removeCustomMaterial({ id: record.id }) :
                    API.removeCustomResources({ resourceIds: [record.id] })
                return commonApiInvoker(request).then(() => {
                    message.success('删除成功')
                    removeRecordsFromList([record])
                    if (props.value.find(item => item.key == getSelectKey(record))) props.onClick(record)
                })
            },
            onCancel() { },
        })
    }

    const handleListScroll = useCallback((e) => {
        if (props.activeKey != "custom" && props.activeKey != "enterpriseCustom") return
        const target = e.currentTarget
        const reachBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 80
        if (!reachBottom) return
        if (!hasMore || loadingMore) return
        loadCustomListPage(pageIndex + 1, false)
    }, [props.activeKey, hasMore, loadingMore, pageIndex, loadCustomListPage])
    const handleFavor = (record) => {
        const resourceType = getResourceTypeByProjectType(props.projectType)
        const resourceParams = { ...(RESOURCE_PARAMS[resourceType] || {}) }
        const resourceKey = getSelectKey(record)
        if (record.isFavorite) {
            const request = API.unfavoriteResource2({
                ...resourceParams,
                resourceId: [record.id],
                resourceKey: [resourceKey],
                custom: !!record?.attr?.custom,
            })
            commonApiInvoker(request).then(res => {
                message.success("已取消收藏")
                setList(pre => {
                    const temp = [...pre]
                    const item = temp.find(item => item.id == record.id)
                    item.isFavorite = false
                    return [...temp]
                })
            })
        } else {
            const request = API.favoriteResource2({
                ...resourceParams,
                resourceId: record.id,
                resourceKey,
                custom: !!record?.attr?.custom,
            })
            commonApiInvoker(request).then(res => {
                message.success("已收藏")
                setList(pre => {
                    const temp = [...pre]
                    const item = temp.find(item => item.id == record.id)
                    item.isFavorite = true
                    return [...temp]
                })
            })
        }
    }
    const handleShare = (record) => {
        const isLogin = Utils.checkLoginStatus(() => handleShare(record))
        if (!isLogin) return
        if (globalOrgInfo?.isPersonal) {
            if (hasOrg) eventBus.emit('OPEN_SELECT_TEAM', { type: SELECT_ORG_TYPE.CHANGEORG, noPersonal: true })
            else eventBus.emit('OPEN_CREATE_TEAM')
            return
        }
        setCurrentMoveResId(record.id)
        setShareOpen(true)
    }
    const handleMove = (record) => {
        setCurrentMoveResId(record.id)
        setMoveOpen(true)
    }
    const handleFolderToggle = (nodeData, e) => {
        e.stopPropagation()
        const isExpanded = expandedKeys.includes(nodeData.key)
        const newKeys = isExpanded
            ? expandedKeys.filter(k => k !== nodeData.key)
            : [...expandedKeys, nodeData.key]
        setExpandedKeys(newKeys)
    }
    const handleFolderSelect = (folderId, folderName) => {
        setActiveFolder(folderId)
        setActiveFolderName(folderName)
        expandFolderAncestors(folderId)
        setFolderOpen(false)
    }
    const folderTitleRender = (nodeData) => {
        const isActive = activeFolder === nodeData.key
        const isExpanded = expandedKeys.includes(nodeData.key)
        const hasChildren = nodeData.children && nodeData.children.length > 0
        const icon = isActive || (hasChildren && isExpanded)
            ? <Iconfont type="icon-Material-FolderOpenOutlined" />
            : <Iconfont type="icon-Material-FolderOutlined" />
        return (
            <div style={{ display: 'flex', width: '100%', overflow: 'hidden', minWidth: 0 }}>
                <div className={`${styles.treeNodeContent} ${isActive ? styles.activeNode : ''}`} style={{ flex: 1, minWidth: 0 }}>
                    {hasChildren ? (
                        <span
                            className={`${styles.customSwitcher} ${isExpanded ? styles.expanded : ''}`}
                            onClick={(e) => handleFolderToggle(nodeData, e)}
                        >
                            <CaretDownOutlined />
                        </span>
                    ) : (
                        <span className={styles.switcherPlaceholder} />
                    )}
                    <span className={styles.nodeIcon}>{icon}</span>
                    <span className={styles.nodeTitle}>{nodeData.title}</span>
                    <span className={styles.nodeCount}>{nodeData.count}</span>
                </div>
            </div>
        )
    }

    const modelFormRef = useRef()
    const [open, setOpen] = useState(false)
    const handleNewModel = () => {
        // 需要登录
        const status = Utils.checkLoginStatus(() => handleNewModel())
        if (!status) return

        setOpen(true)
    }
    const handelOk = async () => {
        try {
            setLoading(true)
            const res = await modelFormRef.current.onSubmit()
            if (res) {
                message.success('模特添加成功')
                // sessionStorage.setItem('hsf_model_id', res)
                setOpen(false)
                updateForce()
            }
        } catch (err) {
            message.warning(err.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <div className={`_beauty_scrollbar`} style={{ ...props.style, paddingRight: 4 }} onScroll={handleListScroll}>
                {customByMaterialList && (
                    <div className={styles.CustomHeader}>
                        <Popover
                            trigger="click"
                            placement="bottomLeft"
                            open={folderOpen}
                            onOpenChange={setFolderOpen}
                            arrow={false}
                            classNames={{ root: styles.FolderPopover }}
                            content={(
                                <div className={`${styles.folderDropdown} _beauty_scrollbar`}>
                                    <div
                                        className={`${styles.treeNodeContent} ${activeFolder === 'refImage_all' ? styles.activeNode : ''}`}
                                        onClick={() => handleFolderSelect('refImage_all', '全部参考图')}
                                    >
                                        <span className={styles.switcherPlaceholder} />
                                        <span className={styles.nodeIcon}>
                                            {activeFolder === 'refImage_all'
                                                ? <Iconfont type="icon-Material-FolderOpenOutlined" />
                                                : <Iconfont type="icon-Material-FolderOutlined" />}
                                        </span>
                                        <span className={styles.nodeTitle}>全部参考图</span>
                                        <span className={styles.nodeCount}>{folderTotal}</span>
                                    </div>
                                    <Tree
                                        treeData={treeData}
                                        expandedKeys={expandedKeys}
                                        onExpand={(keys) => setExpandedKeys(keys)}
                                        selectedKeys={activeFolder === 'refImage_all' ? [] : [activeFolder]}
                                        onSelect={(selectedKeys, info) => {
                                            if (selectedKeys.length > 0) {
                                                handleFolderSelect(selectedKeys[0], info?.node?.title || '')
                                            }
                                        }}
                                        titleRender={folderTitleRender}
                                        blockNode
                                        showIcon={false}
                                        switcherIcon={null}
                                        className={styles.customTree}
                                    />
                                </div>
                            )}
                        >
                            <div className={styles.folderSelect} title={activeFolderName}>
                                <span className={styles.folderSelectName}>{activeFolderName}</span>
                                <CaretDownOutlined className={`${styles.folderSelectArrow} ${folderOpen ? styles.open : ''}`} />
                            </div>
                        </Popover>
                        <Input
                            className={styles.customSearchInput}
                            placeholder="搜索内容"
                            prefix={<SearchOutlined style={{ color: '#BFBFBF' }} />}
                            value={customKeyword}
                            onChange={e => setCustomKeyword(e.target.value)}
                            onPressEnter={() => setCustomKeyword(customKeyword)}
                            allowClear
                        />
                    </div>
                )}
                <div className={styles.SelectTryonPose}>
                    {
                        props.projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ?
                            <div className={styles.UploadTriggerBatch} onClick={handleNewModel}>
                                <div className={styles.UploadContentBatch}>
                                    {loading ? <LoadingOutlined /> : <PlusOutlined />}
                                    <div className={styles.UploadContentExtra}>新增模特</div>
                                </div>
                            </div> :
                            <div className={styles.UploadWrapBatch} onClick={() => setUploadModalOpen(true)}>
                                <div className={styles.UploadContentBatch}>
                                    {loading ? <LoadingOutlined /> : <PlusOutlined />}
                                    <div className={styles.UploadContentExtra}>
                                        <span style={{ fontSize: 14, display: "block", color: "#5B6673", whiteSpace: "nowrap", marginBottom: 5 }}>{loading ? `已上传 ${succNum}/${totalNum}` : "点击上传"}</span>
                                        {/* <span style={{ fontSize: 14, display: "block", color: "#5B6673", whiteSpace: "nowrap" }}>最多30张/次</span> */}
                                    </div>
                                </div>
                            </div>
                    }
                </div>
                {
                    list.map(item => (
                        item.type === 'folder' ?
                            <ReferFolderCard
                                key={item.id}
                                item={item}
                                className={styles.BatchReferFolderCard}
                                onClick={() => handleFolderSelect(item.id, item.name)}
                            /> :
                            <ImageItem
                                key={item.id}
                                hideCustomIcon
                                showTitle
                                projectType={props.projectType}
                                toolGroup={
                                    item.attr?.maskStatus == "failed" ? {
                                        onRemove: () => handleRemove(item)
                                    } : {
                                        onFavor: () => handleFavor(item),
                                        onRemove: () => handleRemove(item),
                                        onMove: customByMaterialList ? () => handleShare(item) : null,
                                        onSort: customByMaterialList ? () => handleMove(item) : null,
                                    }
                                }
                                disabled={!(item?.attr && "maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true)}
                                record={item}
                                selectList={props.value}
                                maxCount={props.maxCount}
                                onClick={props.onClick}
                            />
                    ))
                }
                {!loadingMore && list.length === 0 && (
                    <div className={styles.SelectionListEmpty}>
                        <img src="https://photostudio-ai.oss-cn-hangzhou.aliyuncs.com/photostudio-web/admin/images_v3/icon_empty.svg" alt="" />
                        <span>这里什么也没有哦~</span>
                    </div>
                )}
            </div>
            <MoveFolderModal
                open={moveOpen}
                mode="res"
                menuList={folderList}
                resIds={currentMoveResId ? [currentMoveResId] : []}
                onSuccess={() => {
                    setMoveOpen(false)
                    setCurrentMoveResId('')
                    updateForce()
                }}
                onCancel={() => {
                    setMoveOpen(false)
                    setCurrentMoveResId('')
                }}
            />
            <MoveFolderModal
                open={shareOpen}
                mode="share"
                resIds={currentMoveResId ? [currentMoveResId] : []}
                shareScope="enterprise"
                zIndex={1010}
                onSuccess={() => {
                    setShareOpen(false)
                    setCurrentMoveResId('')
                }}
                onCancel={() => {
                    setShareOpen(false)
                    setCurrentMoveResId('')
                }}
            />
            <PSAIModal
                getContainer={document.body}
                title="新增模特"
                maxWidth={586}
                open={open}
                confirmLoading={loading}
                onOk={handelOk}
                onCancel={() => setOpen(false)}
            >
                <CustomModelForm ref={modelFormRef} />
            </PSAIModal>
            <MaterialUploadModal
                open={uploadModalOpen}
                resourceType={getResourceTypeByProjectType(props.projectType)}
                sampleType={getUploadSampleTypeByProjectType(props.projectType)}
                onUpload={handleModalUpload}
                onSuccess={() => {
                    updateForce()
                }}
                onCancel={() => setUploadModalOpen(false)}
            />
        </>
    )
})

const FavoritePoseList = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        refresh: () => updateForce()
    }))

    const [list, setList] = useState([])
    const [force, setForce] = useState(0)
    const updateForce = useCallback(() => setForce(prev => prev + 1), [])
    useEffect(() => {
        if (props.activeKey != "favorite") return
        props.onChange(list)
    }, [props.activeKey, list])
    const totalRef = useRef(1)
    useEffect(() => {
        const params = {}
        const data = getResourceData(props.projectType)
        commonApiInvoker(API.getFavoriteResources2({
            ...data,
            pageIndex: 1,
            pageSize: totalRef.current,
            ...params,
        })).then(res => {
            const total = res.total
            if (!total) return setList([])
            if (total != totalRef.current) {
                totalRef.current = total
                commonApiInvoker(API.getFavoriteResources2({
                    ...data,
                    pageIndex: 1,
                    pageSize: totalRef.current,
                    ...params,
                })).then(res => {
                    const list = (res?.items ?? []).filter(item => item.name != "00_default_style")
                    setList(
                        list
                            .map(item => ({ ...item, key: getSelectKey(item), isFavorite: true }))
                            .map(item => ({
                                ...item,
                                attr: {
                                    ...item.attr,
                                    title: item?.name || item?.attr?.title || '',
                                    custom: "custom" in item.attr ? item.attr.custom : item.attr.skin == "custom"
                                }
                            }))
                    )
                })
            } else {
                const list = (res?.items ?? []).filter(item => item.name != "00_default_style")
                setList(
                    list
                        .map(item => ({ ...item, key: getSelectKey(item), isFavorite: true }))
                        .map(item => ({
                            ...item,
                            attr: {
                                ...item.attr,
                                title: item?.name || item?.attr?.title || '',
                                custom: "custom" in item.attr ? item.attr.custom : item.attr.skin == "custom"
                            }
                        }))
                )
            }
        })
    }, [force])
    const handleFavor = (record) => {
        const resourceType = getResourceTypeByProjectType(props.projectType)
        const params = { ...(RESOURCE_PARAMS[resourceType] || {}) }
        const resourceKey = getSelectKey(record)
        if (record.isFavorite) {
            commonApiInvoker(API.unfavoriteResource2({
                ...params,
                resourceId: [record.id],
                resourceKey: [resourceKey],
                custom: !!record?.attr?.custom,
            })).then(res => {
                message.success("已取消收藏")
                setList(prev => prev.filter(item => item.id != record.id))
                props.onFavor(record, false)
            })
        } else {
            commonApiInvoker(API.favoriteResource2({
                ...params,
                resourceId: record.id,
                resourceKey,
                custom: !!record?.attr?.custom,
            })).then(res => {
                message.success("已收藏")
                updateForce()
                props.onFavor(record, true)
            })
        }
    }
    const handleRemove = (record) => {
        PSAIModal.confirm({
            title: `确定删除这张自定义模特？`,
            onOk() {
                return commonApiInvoker(API.removeCustomMaterial({
                    id: record.id
                })).then(() => {
                    message.success('删除成功')
                    updateForce({})
                    if (props.value.find(item => item.key == getSelectKey(record))) props.onClick(record)
                })
            },
            onCancel() { },
        })
    }
    return (
        <>
            <div className={`_beauty_scrollbar`} style={{ ...props.style, paddingRight: 4 }}>
                {
                    list.map(item => (
                        <ImageItem
                            key={item.id}
                            showTitle
                            projectType={props.projectType}
                            toolGroup={{
                                onPreview: true,
                                onFavor: () => handleFavor(item),
                                onRemove: () => handleRemove(item)
                            }}
                            record={item}
                            selectList={props.value}
                            maxCount={props.maxCount}
                            onClick={props.onClick}
                        />
                    ))
                }
            </div>
        </>
    )
})

const PoseList = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        refresh: () => updateForce({}),
        onFavor: (record, favor) => {
            setList(pre => {
                const temp = [...pre]
                const item = temp.find(item => item.id == record.id)
                if (!item) return temp
                item.isFavorite = favor
                return [...temp]
            })
        }
    }))
    const [force, updateForce] = useState()
    const [list, setList] = useState([])
    const [pageIndex, setPageIndex] = useState(1)
    const [hasMore, setHasMore] = useState(false)
    const [loadingMore, setLoadingMore] = useState(false)
    const loadingMoreRef = useRef(false)
    const requestIdRef = useRef(0)
    useEffect(() => {
        if (props.activeKey != "default") return
        props.onChange(list)
    }, [props.activeKey, list])
    useEffect(() => {
        loadingMoreRef.current = loadingMore
    }, [loadingMore])

    const loadPresetListPage = useCallback((targetPageIndex, reset = false) => {
        if (props.activeKey != "default") return
        if (loadingMoreRef.current && !reset) return
        const requestId = requestIdRef.current + 1
        requestIdRef.current = requestId
        if (reset) {
            setPageIndex(1)
            setHasMore(false)
        } else {
            setLoadingMore(true)
        }
        const data = getResourceData(props.projectType)
        commonApiInvoker(API.getPresetResources2({
            ...data,
            pageIndex: targetPageIndex,
            pageSize: PAGE_SIZE
        })).then(res => {
            if (requestIdRef.current !== requestId) return
            const total = res?.total || 0
            const nextList = (res?.items ?? [])
                .filter(item => (item.name != "00_random" && item.name != "00_keep" && item.name != "00_default_style"))
                .map(item => ({
                    ...item,
                    key: getSelectKey(item),
                    isFavorite: item.attr.isFavorite,
                    attr: {
                        ...item.attr,
                        title: item?.name || item?.attr?.title || '',
                        custom: false
                    }
                }))
            if (reset) {
                setList(nextList)
            } else {
                setList(pre => [...pre, ...nextList])
            }
            setPageIndex(targetPageIndex)
            setHasMore(targetPageIndex * PAGE_SIZE < total)
        }).finally(() => {
            if (requestIdRef.current !== requestId) return
            setLoadingMore(false)
        })
    }, [props.activeKey, props.projectType])

    useEffect(() => {
        loadPresetListPage(1, true)
    }, [force, props.activeKey, props.projectType, loadPresetListPage])
    const handleFavor = (record) => {
        const resourceType = getResourceTypeByProjectType(props.projectType)
        const resourceParams = { ...(RESOURCE_PARAMS[resourceType] || {}) }
        const resourceKey = getSelectKey(record)
        if (record.isFavorite) {
            commonApiInvoker(API.unfavoriteResource2({
                ...resourceParams,
                resourceId: [record.id],
                resourceKey: [resourceKey],
                custom: false,
            })).then(res => {
                message.success("已取消收藏")
                setList(pre => {
                    const temp = [...pre]
                    const item = temp.find(item => item.id == record.id)
                    item.isFavorite = false
                    return [...temp]
                })
            })
        } else {
            commonApiInvoker(API.favoriteResource2({
                ...resourceParams,
                resourceId: record.id,
                resourceKey,
                custom: false,
            })).then(res => {
                message.success("已收藏")
                setList(pre => {
                    const temp = [...pre]
                    const item = temp.find(item => item.id == record.id)
                    item.isFavorite = true
                    return [...temp]
                })
            })
        }
    }
    const handleListScroll = useCallback((e) => {
        if (props.activeKey != "default") return
        const target = e.currentTarget
        const reachBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 80
        if (!reachBottom) return
        if (!hasMore || loadingMore) return
        loadPresetListPage(pageIndex + 1, false)
    }, [props.activeKey, hasMore, loadingMore, pageIndex, loadPresetListPage])
    return (
        <>
            <div className={`_beauty_scrollbar`} style={{ ...props.style, paddingRight: 4 }} onScroll={handleListScroll}>
                {
                    list.map(item => (
                        <ImageItem
                            key={item.id}
                            showTitle
                            projectType={props.projectType}
                            toolGroup={{
                                onPreview: true,
                                onFavor: () => handleFavor(item),
                            }}
                            record={item}
                            selectList={props.value}
                            maxCount={props.maxCount}
                            onClick={props.onClick}
                        />
                    ))
                }
            </div>
        </>
    )
})

// 选择tryon模特
const BatchReferSelection = (props) => {
    // props.readOnly
    // props.value
    // props.projectType
    const [value, setValue] = useState([...props.value])
    const [activeKey, setActiveKey] = useState("default")
    const handleClick = useCallback((record) => {
        if (props.readOnly) return
        const selectKey = getSelectKey(record)
        if (value.find(item => item.key == selectKey)) {
            setValue(value.filter(item => item.key != selectKey))
        } else {
            const item = { key: selectKey }
            item.url = record.attr?.custom ? (record.attr.tryOnImage || record.imageUrl) : record.imageUrl
            item.custom = record.attr?.custom ? 1 : 0 // 0-预设 1-自定义
            item.colorMask = record.attr?.custom ? record.attr.colorMask : null
            item.title = record.attr?.title ? record.attr.title : null
            setValue([...value, item].slice(props.maxCount == -1 ? 0 : -props.maxCount))
        }
    }, [value])

    const style = {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        alignContent: "flex-start",
        maxHeight: `calc(100vh - 180px)`,
        minHeight: `calc(100vh - 180px)`,
        gap: "10px"
    }

    const [displayList, setDisplayList] = useState([])
    const handleChange = (list) => {
        setDisplayList(list)
    }

    const handleOk = () => {
        props.onChange([...value])
        props.onClose()
    }

    const customRef = useRef()
    const enterpriseRef = useRef()
    const defaultRef = useRef()
    const favorRef = useRef()
    const customUseMaterialList = props.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ||
        props.projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH
    const handleDeleteBatch = () => {
        const displayRecords = []
        for (let item of value) {
            const displayItem = displayList.find(item2 => item2.key == item.key)
            if (!displayItem) continue
            displayRecords.push(displayItem)
        }
        const deleteRecords = displayRecords.filter(item => item.attr?.custom)
        if (deleteRecords.length == 0) return message.warning("当前页的预设模特不可删除")
        const title = displayRecords.length == deleteRecords.length ?
            `确定删除当前页选中的 ${deleteRecords.length} 张自定义模特？` :
            "确定要删除吗？"
        const content = displayRecords.length == deleteRecords.length ? "" :
            <span style={{ whiteSpace: "pre-wrap" }}>{`预设模特不可删除，仅可删除当前页选中的 ${deleteRecords.length} 张自定义模特。`}</span>
        PSAIModal.confirm({
            title: title,
            content: content,
            onOk() {
                const request = customUseMaterialList ?
                    Promise.all(deleteRecords.map(item => commonApiInvoker(API.removeCustomMaterial({ id: item.id })))) :
                    commonApiInvoker(API.removeCustomResources({ resourceIds: deleteRecords.map(item => item.id) }))
                return request.then(() => {
                    message.success('删除成功')
                    const otherList = value.filter(item => !deleteRecords.find(item2 => item2.key == item.key))
                    setValue([...otherList])
                    if (activeKey == "custom") customRef.current?.removeRecords?.(deleteRecords)
                    else if (activeKey == "enterpriseCustom") enterpriseRef.current?.removeRecords?.(deleteRecords)
                    else favorRef.current?.refresh()
                })
            },
            onCancel() { },
        })
    }

    const handleUnfavorBatch = () => {
        const displayRecords = []
        for (let item of value) {
            const displayItem = displayList.find(item2 => item2.key == item.key)
            if (!displayItem) continue
            displayRecords.push(displayItem)
        }
        const favorRecords = displayRecords.filter(item => item.isFavorite)
        if (favorRecords.length == 0) return message.warning("当前页没有选择已收藏的模特")
        const data = getResourceData(props.projectType)
        const resourceType = getResourceTypeByProjectType(props.projectType)
        const resourceParams = { ...(RESOURCE_PARAMS[resourceType] || {}) }
        const resourceList = favorRecords.map(item => item.id)
        const resourceKeyList = favorRecords.map(item => getSelectKey(item))
        const request = customUseMaterialList ? API.unfavoriteResource2({
            ...resourceParams,
            resourceId: resourceList,
            resourceKey: resourceKeyList,
        }) : API.unfavoriteResource2({
            ...data,
            resourceId: resourceList,
            resourceKey: resourceKeyList,
        })
        commonApiInvoker(request).then(res => {
            message.success("已取消收藏")
            if (activeKey == "custom") customRef.current?.refresh()
            else if (activeKey == "enterpriseCustom") enterpriseRef.current?.refresh()
            else if (activeKey == "default") defaultRef.current?.refresh()
            else {
                defaultRef.current?.refresh()
                favorRef.current?.refresh()
            }
        })
    }

    const handleFavor = (record, faovr) => {
        defaultRef.current?.onFavor(record, faovr)
    }

    const handleRemove = ({ key }) => {
        setValue(value.filter(item => item.key != key))
    }

    const selectedListRender = useMemo(() => (
        <div className={styles.SelectedListBatch}>
            {
                value.map(item => {
                    return (
                        <div key={item.key} className={styles.SelectedItem}>
                            <Image src={Utils.getImgThumbnail(item.url)} fallback={fallback} preview={false} />
                            <Iconfont onClick={() => handleRemove(item)} className={styles.Icon} type="icon-DeleteOutlined" />
                        </div>
                    )
                })
            }
        </div>
    ), [value])

    const items = [{
        key: "default",
        label: `预设模特`,
        children: (
            <PoseList
                maxCount={props.maxCount}
                ref={defaultRef}
                projectType={props.projectType}
                activeKey={activeKey}
                value={value}
                style={style}
                onClick={handleClick}
                onChange={handleChange}
            />
        ),
    }, {
        key: "custom",
        label: `个人参考图`,
        children: (
            <CustomPoseList
                ref={customRef}
                maxCount={props.maxCount}
                projectType={props.projectType}
                activeKey={activeKey}
                value={value}
                style={style}
                onClick={handleClick}
                onChange={handleChange}
                materialScope="personal"
            />
        ),
        destroyOnHidden: true
    }, ...(customUseMaterialList ? [{
        key: "enterpriseCustom",
        label: "企业参考图",
        children: (
            <CustomPoseList
                ref={enterpriseRef}
                maxCount={props.maxCount}
                projectType={props.projectType}
                activeKey={activeKey}
                value={value}
                style={style}
                onClick={handleClick}
                onChange={handleChange}
                materialScope="enterprise"
            />
        ),
        destroyOnHidden: true
    }] : []), {
        key: "favorite",
        label: "我的收藏",
        children: (
            <FavoritePoseList
                maxCount={props.maxCount}
                ref={favorRef}
                projectType={props.projectType}
                activeKey={activeKey}
                value={value}
                style={style}
                onClick={handleClick}
                onChange={handleChange}
                onFavor={handleFavor}
            />
        ),
        destroyOnHidden: true
    }]

    return (
        <>
            <div className={styles.SelectTryonPoseWrap}>
                <CloseOutlined className={styles.CloseIcon} onClick={() => props.setDrawOpen(false)} />
                <div className={styles.PoseLeft}>
                    <Tabs
                        size="small"
                        activeKey={activeKey}
                        items={items}
                        onChange={setActiveKey}
                    />
                </div>
                {
                    props.maxCount > 1 &&
                    <div className={`${styles.PoseRight} _beauty_scrollbar`}>
                        <p style={{ marginBottom: 20 }}>已选参考图 {value.length}/{props.maxCount}</p>
                        {selectedListRender}
                    </div>
                }

            </div>

            <div className={styles.FooterBatch}>
                <Button style={{ width: 200, height: 36, marginRight: 12 }} onClick={() => props.setDrawOpen(false)}>取消</Button>
                <Button style={{ width: 200, height: 36 }} type="primary" onClick={handleOk}>确定</Button>
            </div>
        </>

    )
}

export default BatchReferSelection
